document.addEventListener('DOMContentLoaded', function() {
  // Location selector functionality
  const locationSelector = document.getElementById('location-select');
  if (locationSelector) {
    locationSelector.addEventListener('change', function() {
      const selectedLocation = this.value;
      const activeType = document.querySelector('.pricing-switch__btn.is-active');
      const selectedType = activeType.getAttribute('data-pricing-target');

      updatePricingDisplay(selectedLocation, selectedType);

      // Update location icons
      document.querySelectorAll('.location-icon').forEach(icon => {
        icon.classList.remove('is-active');
      });

      const targetIcon = document.querySelector(`.location-icon--${selectedLocation}`);
      if (targetIcon) {
        targetIcon.classList.add('is-active');
      }
    });
  }

  // Pricing switch functionality
  const pricingButtons = document.querySelectorAll('.pricing-switch__btn');
  pricingButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      // Prevent default button behavior (form submission)
      e.preventDefault();

      // Remove active class from all buttons
      pricingButtons.forEach(btn => btn.classList.remove('is-active'));

      // Add active class to clicked button
      this.classList.add('is-active');

      // Get the selected location
      const selectedLocation = document.getElementById('location-select').value;

      // Get the target pricing type
      const targetType = this.getAttribute('data-pricing-target');

      // Update pricing display with both location and type
      updatePricingDisplay(selectedLocation, targetType);
    });
  });

  // Function to update pricing display based on selected location and type
  function updatePricingDisplay(location, type = null) {
    // Hide all pricing cards
    document.querySelectorAll('.pricing-cards').forEach(cards => {
      cards.classList.remove('is-active');
    });

    // If type is provided, show cards matching both location and type
    if (type) {
      document.querySelector(`.pricing-cards[data-pricing-location="${location}"][data-pricing-type="${type}"]`).classList.add('is-active');
    } else {
      // Otherwise, just show cards matching the location
      document.querySelector(`.pricing-cards[data-pricing-location="${location}"]`).classList.add('is-active');
    }
  }
});
